import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_OoounitListComponent from "../components/_FM_ooounit/_FM_OoounitListComponent";
import _FM_OoounitFormComponent from "../components/_FM_ooounit/_FM_OoounitFormComponent";
import _FM_OoounitShowComponent from "../components/_FM_ooounit/_FM_OoounitShowComponent";
import _FM_UnitFormComponent from "../components/_FM_unit/_FM_UnitFormComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_OoounitPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('ooo_units') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/ooounit')
  }, []);

  return (
    <div className="_FM_OoounitPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/ooounit"}/>
      <Panel>
        <_FM_OoounitListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/ooounit');
               }}>
        <_FM_OoounitFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/ooounit');
               }}>
        <_FM_OoounitShowComponent />
      </Sidebar>
      <Sidebar position="right" visible={action === 'update' && entity === 'unit'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/ooounit');
               }}>
        <_FM_UnitFormComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_OoounitPage);
